<template>
  <div>
    <div class="iv-home iv-p-b-40">
      <div class="iv-home-content iv-main-width iv-m-t-24">
        <section class="iv-home__aside">
          <UserInfo class="iv-pull-left"></UserInfo>
          <HeartMailBox class="iv-pull-left"></HeartMailBox>
          <voiceAdvice class="iv-pull-left"></voiceAdvice>
          <questionnaire class="iv-pull-left"></questionnaire>
          <interactiveQuiz class="iv-pull-left"></interactiveQuiz>
          <InstitutionalIndex class="iv-pull-left"></InstitutionalIndex>
        </section>
        <section class="iv-home__content">
          <div class="iv-home-bfc">
              <p class="iv-home-block iv-pull-left iv-pointer" @click="toDealtPage('dealtList')">
                <Iconfont type="daibangongzuo" class="iv-p-l-16 iv-fs-30"></Iconfont>
                <span class="iv-fc-65 iv-fs-16 iv-home-block-span">我的待办</span>
                <span class="iv-home-block-right iv-fs-26">{{handleCount}}</span>
              </p>
              <p class="iv-home-block iv-pull-right iv-pointer" @click="toDealtPage('messageList')">
                <Iconfont type="xiaoxifabu" class="iv-p-l-16 iv-fs-24"></Iconfont>
                <span class="iv-fc-65 iv-fs-16 iv-home-block-span">我的消息</span>
                <span class="iv-home-block-right iv-fs-26">{{total}}</span>
              </p>
          </div>
          <FunctionBlock></FunctionBlock>
          <RecommendActivities class="iv-pull-right"></RecommendActivities>
          <NewsCenter class="iv-pull-right"></NewsCenter>
          <Project class="iv-pull-right"></Project>
          <CourseList class="iv-pull-right"></CourseList>
        </section>
      </div>
  </div>
  </div>
</template>

<script>
import Project from './components/project'
import CourseList from './components/course'
import Iconfont from '@/components/iconfont'
import UserInfo from './components/user-info'
import NewsCenter from './components/news-center'
import HeartMailBox from './components/heart-mailbox'
import FunctionBlock from './components/function-block'
import InstitutionalIndex from './components/institutional-index'
import RecommendActivities from './components/recommend-activities'
import voiceAdvice from './components/voiceAdvice.vue'
import questionnaire from './components/questionnaire.vue'
import interactiveQuiz from './components/interactiveQuiz.vue'

export default {
  data(){
    return{
      total: 0,
      handleCount: 0
    }
  },
  created () {
    this.getTodoCount()
    this.getNnreadList()
    this.getElearningAreaName()
  },
  methods: {
    // 我的总消息数
    getNnreadList () {
      this.$ajax({
        url: '/api-uum/innermessage/unreadNumber/get',
        method: 'get',
      }).then((data) => {
        this.total = data.data.data.count
      })
    },
    // 我的待办数
    getTodoCount () {
      this.$ajax({
        url: '/api-uum/todo/getTodoCount',
        method: 'get',
      }).then((data) => {
        this.handleCount = data.data.data.handleCount
        // this.showCount = data.data.data.showCount
      })
    },
    //跳转列表
    toDealtPage (name) {
      this.$router.push({
        name: name
      })
    },
    //获取在线学习跳转域名
    getElearningAreaName () {
      this.$ajax({
        url: '/api-uum/boe/getElearningUrl',
        method: 'get',
        data: {}
      }).then(({data}) => {
        sessionStorage.setItem('elearningName', data.data)
      })
    }
  },
  components: {
    Project,
    UserInfo,
    Iconfont,
    NewsCenter,
    CourseList,
    HeartMailBox,
    FunctionBlock,
    InstitutionalIndex,
    RecommendActivities,
    voiceAdvice,
    questionnaire,
    interactiveQuiz
  }
}
</script>

<style lang="scss" scoped>
.iv-home {
  .iv-home-content {
    display: flex;
    flex-direction: row;
    .iv-home__aside {
      flex-basis: 384px;
    }
    .iv-home__content {
      margin-left: 24px;
      flex: 1;
    }
    .iv-home-block {
      // width: 384px;
      &:first-child {
        margin-right: 24px;
      }
      flex: 1;
      height: 88px;
      line-height: 88px;
      background: #FFFFFF;
      border-radius: 16px;
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      .iconfont {
        font-size: 45px;
        color: #009AD8;
      }
      .iv-home-block-span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 76px;
        font-weight: 400;
      }
      .iv-home-block-right {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 32px;
      }
    }
    .iv-home-bfc {
      display: flex;
      overflow: hidden;
    }
  }
}
</style>
